import React, { useEffect, useState } from "react";

const closedStatuses = ["Completed", "Cancelled", "NoShow"];

function ReservationCard({ res, onEdit, onStatus, onView }) {
  const [actionsOpen, setActionsOpen] = useState(false);
  const tableName = res.restaurantTable?.tableName || res.tableName || "—";
  const status = res.status || "";
  const canCancel = !closedStatuses.includes(status);
  const canCheckIn = status === "Confirmed" || status === "Booked";
  const canComplete = status === "CheckedIn";
  const hasActions = canCancel || canCheckIn || canComplete;

  useEffect(() => {
    if (!actionsOpen) return undefined;
    const onKeyDown = (event) => {
      if (event.key === "Escape") setActionsOpen(false);
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [actionsOpen]);

  const choose = (callback) => {
    setActionsOpen(false);
    callback();
  };

  const primaryAction = canCheckIn
    ? { label: "Check in", run: () => onStatus(res, "CheckedIn") }
    : canComplete
      ? { label: "Complete visit", run: () => onStatus(res, "Completed") }
      : canCancel
        ? { label: "Edit details", run: () => onEdit(res) }
        : null;

  return <li className="reservation-card">
    <div className="card-header"><div><h4>{res.customerName}</h4>{res.sourceChannel && res.sourceChannel !== "Manual" && <span className="reservation-source">{res.sourceChannel}</span>}</div><span className={`status ${status.toLowerCase()}`}>{status === "Booked" ? "Confirmed" : status}</span></div>
    <div className="card-body">
      <p><strong>Phone</strong> {res.mobileNumber}</p>
      <div className="row"><p><strong>Date</strong> {res.reservationDate?.split("T")[0]}</p><p><strong>Time</strong> {res.reservationTime?.slice(0, 5)}</p></div>
      <div className="row"><p><strong>Guests</strong> {res.numberOfGuests}</p><p><strong>Table</strong> T-{tableName}</p></div>
    </div>
    {primaryAction && <div className="reservation-card-actions">
      <button type="button" className="card-primary-action" onClick={primaryAction.run}>{primaryAction.label}</button>
      {hasActions && <button type="button" className="card-more-action" aria-label={`More actions for ${res.customerName}`} aria-haspopup="dialog" onClick={() => setActionsOpen(true)}>•••</button>}
    </div>}

    {actionsOpen && <div className="reservation-action-sheet-backdrop" role="presentation" onMouseDown={(event) => event.target === event.currentTarget && setActionsOpen(false)}>
      <section className="reservation-action-sheet" role="dialog" aria-modal="true" aria-labelledby={`reservation-actions-${res.reservationId}`}>
        <div className="reservation-action-sheet-handle" aria-hidden="true" />
        <div className="reservation-action-sheet-heading"><div><p>Reservation actions</p><h3 id={`reservation-actions-${res.reservationId}`}>{res.customerName}</h3></div><button type="button" aria-label="Close actions" onClick={() => setActionsOpen(false)}>×</button></div>
        <div className="reservation-action-sheet-options">
          <button type="button" onClick={() => choose(() => onView(res))}>View details</button>
          {primaryAction?.label !== "Edit details" && <button type="button" onClick={() => choose(() => onEdit(res))}>Edit details</button>}
          {canCheckIn && <button type="button" onClick={() => choose(() => onStatus(res, "CheckedIn"))}>Check in</button>}
          {canComplete && <button type="button" onClick={() => choose(() => onStatus(res, "Completed"))}>Complete visit</button>}
          {canCheckIn && <button type="button" onClick={() => choose(() => onStatus(res, "NoShow"))}>Mark no-show</button>}
          {canCancel && <button type="button" className="reservation-sheet-danger" onClick={() => choose(() => onStatus(res, "Cancelled"))}>Cancel reservation</button>}
        </div>
      </section>
    </div>}
  </li>;
}

export default ReservationCard;
